import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { ThemeProvider, CssBaseline } from '@mui/material'
import theme from './theme/theme'
import { AuthProvider, useAuth } from './hooks/useAuth'
import { PlantProvider } from './hooks/usePlantContext'
import AppShell from './components/layout/AppShell'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import PlanList from './pages/PlanList'
import PlanningBoard from './pages/PlanningBoard'
import PlanComparison from './pages/PlanComparison'
import DataHub from './pages/DataHub'
import Reports from './pages/Reports'
import Rules from './pages/Rules'
import ChangeoverTimes from './pages/supporting/ChangeoverTimes'
import Capacity from './pages/supporting/Capacity'
import ItemRunRates from './pages/supporting/ItemRunRates'
import CapacityRunRates from './pages/supporting/CapacityRunRates'
import ItemData from './pages/supporting/ItemData'
import Demand from './pages/supporting/Demand'
import CurrentInventory from './pages/supporting/CurrentInventory'
import ECConversion from './pages/supporting/ECConversion'
import PalletCount from './pages/supporting/PalletCount'
import BusinessCalendar from './pages/supporting/BusinessCalendar'

function ProtectedRoute({ children }) {
  const { authenticated } = useAuth()
  if (!authenticated) return <Navigate to="/login" replace />
  return children
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <PlantProvider>
              <AppShell />
            </PlantProvider>
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="plans" element={<PlanList />} />
        <Route path="plans/:planId/grid" element={<PlanningBoard />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports/comparison" element={<PlanComparison />} />
        <Route path="data" element={<DataHub />} />
        <Route path="rules" element={<Rules />} />
        <Route path="supporting" element={<Outlet />}>
          <Route path="changeover" element={<ChangeoverTimes />} />
          <Route path="capacity" element={<Capacity />} />
          <Route path="item-run-rates" element={<ItemRunRates />} />
          <Route path="capacity-run-rates" element={<CapacityRunRates />} />
          <Route path="item-data" element={<ItemData />} />
          <Route path="demand" element={<Demand />} />
          <Route path="inventory" element={<CurrentInventory />} />
          <Route path="ec-table" element={<ECConversion />} />
          <Route path="pallet-count" element={<PalletCount />} />
          <Route path="calendar" element={<BusinessCalendar />} />
        </Route>
      </Route>
    </Routes>
  )
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  )
}
